export default "__VITE_ASSET__CtwFqWKv__"